<!--Info-->
<div>
	<p style="max-width: 450px; font-size: 11px; font-weight: normal">
		You are about to remove the {{ RoleDesc }} from {{ UserCount }} user{{ UserCount != 1 ? "s" : "" }}. Do you want to remove this role just for
		<span style="font-weight: bold">{{ SchoolFullName }}</span> or remove this role for all schools?
	</p>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onSchool()">Remove for School</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onDistrict()">Remove for District</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
